//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VideoControls from '@/elements/editorial/video/video-controls.vue'

export default {
  name: 'video-background',
  extends: VideoControls,
}
